// import CustomButton from "atoms/customButton/CustomButton";
import styles from "./Overview.module.scss";
// import SyntaxHighlighter from "react-syntax-highlighter";
// import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { KeyRound, TriangleDashed } from "lucide-react";
import { API_REFRENCE_LINK } from "lib/Constants";

interface OverviewProps {
	onNext: () => void;
}

const Overview = ({ onNext }: OverviewProps) => {
	return (
		<div className={`${styles.overview}`}>
			<div className={`${styles.overview__top}`}>
				<div className={`${styles.overview__left}`}>
					<h3>Developer quickstart</h3>
					<p>Learn the basics and make your first request with the Swan API.</p>
					{/* <CustomButton handleFunc={() => onNext()} buttonText={"Get started"} className="button sm" /> */}
				</div>

			</div>
			<div className={`${styles.overview__quickLinks}`}>
				<h2>Quick Links</h2>
				<div className={`${styles.overview__quickLinksList} flex-wrap`}>
					<span onClick={()=>onNext()}>
						<KeyRound /> Create an API Key
					</span>
					<a href={API_REFRENCE_LINK} target="_blank" rel="noreferrer">
						<TriangleDashed />
						API Reference
					</a>
				</div>
			</div>
		</div>
	);
};
export default Overview;
